import { useCallback } from 'react';
import { t } from '@lingui/core/macro';
import { Button, ButtonGroup, IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { SearchAggregationType, } from 'shared/domains/apollo/generated/types';
import { SearchableMenu, SearchableMenuGroupedItems } from 'shared/domains/common-ui/SearchableMenu';
import { getAllowedProperties } from './getAllowedProperties';
import { getDefaultDateHistogramValue } from '../DateHistogramInput/getDefaultDateHistogramValue';
import { getDefaultDateRangeValue } from '../DateRangeInput/getDefaultDateRangeValue';
import { getDefaultMetricValue } from '../MetricInput/getDefaultMetricValue';
import { getDefaultTermsValue } from '../TermsInput/getDefaultTermsValue';
import { getDefaultTopHitsValue } from '../TopHitsInput/getDefaultTopHitValue';
export function SelectDataPoint(props) {
    const { name, label, icon, onRemove, selectedValue } = props;
    const [, , helpers] = useField(name);
    const { items, groups } = getAllowedProperties();
    const selectValue = useCallback((aggregationType, value) => {
        const setValue = (data) => {
            helpers.setTouched(true);
            helpers.setValue(data);
        };
        switch (aggregationType) {
            case SearchAggregationType.DateHistogram:
                return setValue(getDefaultDateHistogramValue(value));
            case SearchAggregationType.DateRange:
                return setValue(getDefaultDateRangeValue(value));
            case SearchAggregationType.Metric:
                return setValue(getDefaultMetricValue(value));
            case SearchAggregationType.Terms:
                return setValue(getDefaultTermsValue(value));
            case SearchAggregationType.TopHits:
                return setValue(getDefaultTopHitsValue(value));
            default:
                return undefined;
        }
    }, [helpers]);
    return (<ButtonGroup>
      <SearchableMenu items={items} groups={groups} itemGroupKey="type" keys={['label']} placeholder={t({
            message: 'Search',
            comment: 'Insights widget form: Data point selection search input',
        })} renderTarget={<Button type="button" size="small" appearance="secondary">
            {icon}
            {!selectedValue && label}
            {selectedValue}
          </Button>}>
        {({ items: nodes }) => (<SearchableMenuGroupedItems nodes={nodes} flat render={(item) => (<Menu.Item key={item.id} onClick={() => selectValue(item.type, item.field)}>
                {item.label}
              </Menu.Item>)}/>)}
      </SearchableMenu>
      {onRemove && (<IconButton type="button" size="small" appearance="secondary" onClick={onRemove} aria-label={t({
                message: 'Remove',
                comment: 'Insights widget form: Data point selection remove button',
            })}>
          <Falcon icon="close"/>
        </IconButton>)}
    </ButtonGroup>);
}
